/**
 * @author: Scoons @ 29/08/2017 18:10
 */
const add = (state, deal) => {
  state.push(deal)
  return state.slice(0, state.length)
}

const remove = (state, deal) => {
  for (let i = 0; i < state.length; i++) {
    if (state[i].uuid === deal.uuid) {
      state.splice(i, 1)
      break
    }
  }
  return state.slice(0, state.length)
}

const update = (state, deals) => {
  return [...deals]
}

const FavouritesReducer = (state = [], action) => {
  switch (action.type) {
    case "ADD_FAV":
      return add(state, action.deal)
    case "REMOVE_FAV":
      return remove(state, action.deal)
    case "UPDATE_FAVS":
      return update(state, action.deals)
    default:
      return state
  }
}

export default FavouritesReducer
